import { render, staticRenderFns } from "./LargePayers.vue?vue&type=template&id=f971592c&scoped=true&"
import script from "./LargePayers.vue?vue&type=script&lang=js&"
export * from "./LargePayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f971592c",
  null
  
)

export default component.exports